/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private readonly http: HttpClient) {
  }

  /**
   * Send a file over to the API endpoint that is passed in as a parameter via a POST call
   *
   * @param file the file that is being uploaded
   * @param apiUrl the API endpoint url
   *
   * @return Observable<any> the response from the API
   */
  upload(file: File, apiUrl: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this.http.post<any>(apiUrl, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
